import Paper from "@material-ui/core/Paper";
import ChangePassword from "../../components/ChangePassword";

function LSHConfig() {
  return (
    <div className="layout-dashboard-container">
      <Paper style={{ padding: "2rem" }}>
        <h1
          style={{ fontWeight: "normal", fontSize: "1.5rem", color: "#232f3e" }}
        >
          Configuración
        </h1>
        <br />
        <h3 style={{ fontWeight: "normal", color: "#232f3e" }}>
          Administra tu perfil y configuración de cuenta.
        </h3>
      </Paper>
      <br />
      <ChangePassword />
    </div>
  );
}

export default LSHConfig;
